import {Component, AfterViewInit, ElementRef, ViewChild} from '@angular/core';
import {PaginatorComponent} from '../../shared/paginator';
import {MatSort} from '@angular/material/sort';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {RestDataSource} from '../../shared/rest-data-source';
import {AdminApi, Site} from '../admin-api';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SelectionModel} from '@angular/cdk/collections';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {ConfirmDialogComponent} from '../../e-signature/confirm-dialog/confirm-dialog.component';
import {Toast} from '../../shared/toast/toast';
import {CreateSiteComponent} from '../create-site/create-site.component';
import {AddSiteComponent} from '../add-site/add-site.component';
import {CorporateMemberComponent} from '../../dms/corporate-member/member.component';
import {IdexService} from '../../idex.service';

@Component({
   selector: 'app-site-list',
   templateUrl: './site-list.component.html',
   styleUrls: ['./site-list.component.css']
})
export class SiteListComponent implements AfterViewInit {

   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   @ViewChild('btnDelSite', {static: true}) public buttonDel: MatButton;
   private memberDialog: MatDialogRef<CorporateMemberComponent>;
   displayedColumns = ['select', 'no', 'site_name', 'site_code', 'created_by', 'created_date', 'update_by', 'update_date', 'menu'];
   dataSource = new RestDataSource<Site>();
   selection = new SelectionModel<Site>(true, []);
   selectedRowIndex = -1;
   error: string;
   tin: string;

   user: any;
   role: string;
   isAdmin: boolean;

   searching: string;
   searchFocused: boolean;
   preventBlur: boolean;
   searchResult: any[];
   searchvalue: any;
   searchSize = 8;
   memberSearchList = [];
   private timer: any;
   username: any;

   constructor(private api: AdminApi, private service: IdexService, public dialog: MatDialog,
               public toast: Toast, private router: Router,
               public translate: TranslateService,private adminService: AdminApi) {

      this.user = this.service.user;
      this.tin = window.localStorage.getItem('tin');
      let user = JSON.parse(localStorage.getItem('idex-user') || '{}');
      this.username = user?.email;
      this.loadUserGroupCompany();
      this.getRole();
   }

   ngAfterViewInit() {
      localStorage.removeItem('sortOrder');
      localStorage.removeItem('sortDirect');
      this.getData();
   }

   getRole() {
      this.adminService.getRole(this.user.username,this.tin)
         .subscribe((data: any) => {
            if(data){
               this.role = data.role;
               this.isAdmin = this.role === 'Admin';
            }
      });
   }

   getData() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.clearSelection();
      this.dataSource.setFilter({'tin': this.tin});
      this.dataSource.changes.subscribe((params: any) => {
         this.loader.show();
         this.api.listSite(params, this.username)
            .subscribe(
               data => {
                  this.selectedRowIndex = -1;
                  this.buttonDel.disabled = true;
                  this.dataSource.loaded(data);
                  this.wrapper.nativeElement.scrollTop = 0;
               }, e => {
                  this.error = e.message;
               }
            ).add(() => this.loader.hide());
      });
      setTimeout(() => { this.dataSource.loadData() }, 500);
   }

   loadUserGroupCompany(){
      this.service.get('/work/' + this.tin + '/company/usergroup?filter=')
         .subscribe(
            data => {
               if (data && data.length > 0) {
                  this.memberSearchList = data;
               } else {
                  this.memberSearchList = [];
               }
         });
   }

   toggleAll() {
      this.dataSource.toggleAll();
      this.disableButton();
   }

   toggleSelection(row: any) {
      this.dataSource.toggle(row);
      this.disableButton();
   }

   isSelected(row: any) {
      const isSelected = this.dataSource.isSelected(row);
      this.disableButton();
      return isSelected;
   }

   disableButton() {
      const numSelected = this.dataSource.selected.length;
      numSelected > 0 ? this.buttonDel.disabled = false : this.buttonDel.disabled = true;
   }

   deleteSites() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('site.delete-msg').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isMsg = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const sites: any[] = [];
            this.dataSource.selected.forEach((site) => {
               if (site.siteCode !== this.tin) {
                  sites.push(site);
               }
            });
            this.loader.show();
            this.buttonDel.disabled = true;
            this.api.deleteSite(sites).subscribe(res => {
               this.getData();
               this.toast.success(res);
            }, e => {
               this.buttonDel.disabled = false;
               this.toast.error(e.message);
            }).add(() => {
               this.loader.hide();
            });
         }
      });
   }

   deleteSite(site: any): void {
      this.service.get('/site/' + site.siteCode).subscribe(() => {
         const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
         });
         this.translate.get('site.delete-msg').subscribe(s => {
            dialogRef.componentInstance.messageWarning = s;
            dialogRef.componentInstance.isMsg = true;
         });
         dialogRef.afterClosed().subscribe(result => {
            if (result) {
               const sites: any[] = [];
               if (site.siteCode !== this.tin) {
                  sites.push(site);
               }
               this.loader.show();
               this.buttonDel.disabled = true;
               this.api.deleteSite(sites).subscribe(res => {
                  this.getData();
                  this.toast.success(res);
               }, e => {
                  this.buttonDel.disabled = false;
                  this.toast.error(e.message);
               }).add(() => {
                  this.loader.hide();
               });
            }
         });
      });

   }

   openCreateSite(): void {
      const createSiteDialog = this.dialog.open(CreateSiteComponent, {
         disableClose: true,
         data: this
      });
      createSiteDialog.afterClosed().subscribe(result => {
         if (result) {
            setTimeout(() => this.getData(), 500);
         }
      });
   }

   openAddSite(): void {
      const addSiteDialog = this.dialog.open(AddSiteComponent, {
         minHeight: '600px',
         minWidth: '800px',
         disableClose: true,
         data: this
      });
      addSiteDialog.afterClosed().subscribe(result => {
         if (result) {
            setTimeout(() => this.getData(), 500);
         }
      });
   }

   openUpdateSiteDialog(site: Site): void {
      this.service.get('/site/' + site.siteCode).subscribe(() => {
         const data = {
            'siteName': site.siteName,
            'siteCode': site.siteCode
         }
         const createSiteDialog = this.dialog.open(CreateSiteComponent, {
            disableClose: true,
            data: data
         });
         createSiteDialog.afterClosed().subscribe(result => {
            if (result) {
               setTimeout(() => this.getData(), 500);
            }
         });
      });

   }

   openAddMember(site: Site): void {
      this.service.get('/site/' + site.siteCode)
         .subscribe(
            () => {
               this.memberDialog = this.dialog.open(CorporateMemberComponent, {
                  disableClose: true,
                  data: this,
                  width: '900px'
               });
               this.memberDialog.componentInstance.isFindByCompany = true;
               this.memberDialog.componentInstance.searchList = this.memberSearchList;
               this.memberDialog.componentInstance.tin_id = site.siteCode;
               this.memberDialog.componentInstance.user_role = 'Admin';
               this.memberDialog.componentInstance.translate = this.translate;
            }
         );
   }

   onSearch(filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[%|^{}[\]\\]/g.test(value)) {
         this.translate.get('alert.create_folder_errors').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.getSite(filterValue);
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         if (this.timer == null) {
            this.getSite(kw);
         }
      }, 300);
   }

   selectSearchItem(item) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.searching = item.siteName.trim();
      let filterValue = this.searching.toLowerCase();
      this.dataSource.filter = filterValue;
   }

   getSite(kw: string) {
      let params = {
         'searchText': kw,
         'tin': this.tin,
         'sort': 'site_name',
         'size': this.searchSize
      }
      this.api.listSite(params, this.username)
      .subscribe(
         data => {
            this.searchResult = data.content;
         }, e => {
            this.error = e.message;
         }
      ).add(() => this.loader.hide());
   }
}
